jQuery(document).on("page.ready", function() {
  $ = jQuery;

  if ($("main.blog-single").length) {
    function marginAdjuster() {
      var menuHeight = $(".menu-container").height();
      $(".hero-image").css("padding-top", menuHeight + "px");
    }
    // marginAdjuster();

    // $(window).on("load resize", function(e) {
    //   marginAdjuster();
    // });

    setTimeout(function() {
      $(".photo-slider-section .owl-carousel").each(function() {
        var $slider = $(this);
        $slider.owlCarousel({
          autoplay: false,
          nav: true,
          items: 4,
          singleItem: false,
          rewind: false,
          slideBy: "page",
          dots: true,
          margin: 20,
          loop: true,
          autoWidth: true,
          navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="translate(-6 -5.379)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M107.824 18H7.5" transform="translate(0 12.95)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M30.95 54.4L7.5 30.95 30.95 7.5"/></g></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="rotate(180 50.912 24.51)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M100.324 0H0" transform="translate(0 23.45)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M23.45 46.9L0 23.45 23.45 0"/></g></svg>'
          ],
          responsive: {
            0: {
              items: 1,
              margin: 10,
              autoWidth: true,
              center: true
            },
            768: {
              items: 2,
              margin: 10,
              autoWidth: true
            },
            1200: {
              items: 4,
              autoWidth: true
            }
          }
        });
      });
    }, 300);
  } // end check for page
});
